export default __webpack_public_path__ + "static/linkedin-a9dc4a189566e04c6e6d9a19691efe2d.png";